import { z } from 'zod';

const FormSchema = z.object({
  companyId: z.string().min(1, 'Campo obrigatório'),
  produtos: z
    .array(
      z.object({
        produto: z.string().min(1, 'Campo obrigatório'),
        placas: z.string().min(1, 'Campo obrigatório'),
      })
    )
    .min(1, '*Adicione pelo menos um item'),
});

type FormValues = z.infer<typeof FormSchema>;

export { FormSchema, type FormValues };
